import React from 'react';
import { LazyImage } from 'common/components/LazyImage';

export const MAX_IMAGE_WIDTH = 500;

interface Props {
  image: string;
  quote: string;
  user: string;
  userSubtitle: string;
}

export const CommunityContentCard: React.FC<Props> = ({
  image,
  quote,
  user,
  userSubtitle,
}) => (
  <div className="community-content">
    <div className="community-content__image-box">
      <LazyImage
        src={`${image}?w=${MAX_IMAGE_WIDTH}`}
        className="community-content__image"
      />
    </div>
    <div className="community-content__lower-section">
      <blockquote className="community-content__quote">{quote}</blockquote>
      <div className="community-content__user">
        <cite className="community-content__user__name">{user}</cite>
        <div className="community-content__user__subtitle">{userSubtitle}</div>
      </div>
    </div>
  </div>
);
